import {Component} from '@angular/core';
import {LoadingController, NavController, NavParams} from 'ionic-angular';
import {WorkReportProvider} from "../../providers/work-report/work-report";
import {ToastProvider} from "../../providers/toast/toast";
import {WorkReportEditPartListPage} from "../work-report-edit-part-list/work-report-edit-part-list";
import {ValidationProvider} from "../../providers/validation/validation";
import {Camera, CameraOptions} from "@ionic-native/camera";

/**
 * Generated class for the WorkReportEditPartPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-work-report-edit-part',
  templateUrl: 'work-report-edit-part.html',
})
export class WorkReportEditPartPage {

  part: any = {};
  salesOrder: any;
  workReport: any;
  partNumbers: any = [];
  images: any = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private workReportProvider: WorkReportProvider,
    private loadingCtrl: LoadingController,
    private toast: ToastProvider,
    private validation: ValidationProvider,
    private camera: Camera
  ) {
    this.part = this.navParams.get('part');
    this.salesOrder = this.navParams.get('salesOrder');
    this.workReport = this.navParams.get('workReport');

    if (!this.part)
      this.part = {
        part_ok: 0,
        part_mostly_ok: 0,
        part_not_ok: 0,
        part_no: {
          part_no: -1
        },
        error_id: {
          error_line_ids: []
        },
        error_id2: {
          error_line_ids: []
        },
      };

    for (let salesOrderPartDetails of this.salesOrder.part_details_ids) {
      if (this.partNumbers.indexOf(salesOrderPartDetails.part_no) === -1)
        this.partNumbers.push(salesOrderPartDetails.part_no);
    }
  }

  async ionViewDidEnter() {
    if (this.part.id) {
      this.part = await this.workReportProvider.loadPart(this.part.id);

      this.loadImages();
    }
  }

  async loadImages() {
    this.workReportProvider.getImages(this.part.id).then(data => {
      // @ts-ignore
      this.images = data.results;

      if (!this.images || typeof this.images.length == 'undefined') this.images = [];
    });
  }

  makePicture() {
    const options: CameraOptions = {
      quality: 90,
      targetWidth: 1920,
      targetHeight: 1080,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      correctOrientation: true
    };

    this.camera.getPicture(options).then((imageData) => {
      this.images.push({
        id: 0,
        file: imageData
      });
    }, (err) => {
      // Handle error
      alert("Fehler: " + err);
    });
  }

  async save() {
    this.validation.init();

    let loading = this.loadingCtrl.create({content: "Teilebericht wird erstellt, bitte warten ..."});
    loading.present();

    let partId = await this.workReportProvider.savePart(this.workReport.name, this.part, this.images);

    this.part = await this.workReportProvider.loadPart(partId);

    loading.dismiss();

    if (!partId)
      this.toast.error('Teil konnte nicht gespeichert werden, es ist ein Fehler aufgetreten.');

    return partId
  }

  async saveAndGoBack() {
    let success = await this.save();

    if (success)
      this.navCtrl.pop();
  }

  async goToPartList(mode: any) {
    let success = await this.save();

    if (success) {
      this.navCtrl.push(WorkReportEditPartListPage, {
        mode: mode,
        part: this.part,
        salesOrder: this.salesOrder,
        workReport: this.workReport
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/work-report-edit-part/work-report-edit-part.ts